﻿import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import { menuClasses } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select, { selectClasses } from '@mui/material/Select';

function TopLevelFilters({ ...props }) {
  const [val, setVal] = useState('All');

  return (
    <FormControl>
      <Select
        disableUnderline
        variant="standard"
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          sx: {
            marginBlock: '0.5rem',
            [`& .${menuClasses.paper}`]: {
              borderRadius: '12px',
            },
            [`& .${menuClasses.list}`]: {
              paddingTop: 0,
              paddingBottom: 0,
              background: 'white',
              '& li': {
                paddingTop: '12px',
                paddingBottom: '12px',
              },
              '& li:hover': {
                background: '#e3f2fd',
              },
              '& li.Mui-selected': {
                color: 'white',
                background: '#1565c0',
              },
              '& li.Mui-selected:hover': {
                background: '#1976d2',
              },
            },
          },
        }}
        IconComponent={ExpandMoreIcon}
        value={val}
        onChange={(event) => {
          setVal(event.target.value);
          props.setPolicyStatus(event.target.value);
        }}
        sx={{
          minWidth: 200,
          [`& .${selectClasses.select}`]: {
            background: 'white',
            color: '#1565c0',
            //borderRadius: "12px",
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '14px',
            paddingBottom: '15px',
            fontWeight: '500',
            boxShadow: '0px 5px 8px -3px rgba(0,0,0,0.14)',
            '&:focus': {
              borderRadius: '12px',
              background: 'white',
              borderColor: '#4285f4',
            },
          },
          [`& .${selectClasses.icon}`]: {
            right: '12px',
          },
        }}
      >
        <MenuItem value={'All'}>Show All</MenuItem>
        <MenuItem value={'P'}>Show Pending</MenuItem>
        <MenuItem value={'A'}>Show Active Last 90 Days</MenuItem>
      </Select>
    </FormControl>
  );
}

export { TopLevelFilters };
